module.exports = __webpack_public_path__ + "checker_white.e3da0df.png";